module.exports = __webpack_public_path__ + "img/logo.ecc266e1.png";